import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';
// Q6t62QwXSyRusRufl0KeAdTs7iM2
/**
{
  "cardId": "1071580348",
  "idType": "CC",
  "phoneNumber": "3197807871",
  "name": "Milton Horacio Chávez Aguirre",
  "address": {
    "address": "Calle 71A#71-38",
    "city": "Bogotá",
  },
  "email": "miltonx93@gmail.com",
  "features": [
    {
      "key": "program",
      "value": "Administrative Support in Clinical Settings (STC)"
    },
    {
      "key": "origin",
      "value": "access"
    },
  ]
}
 */

function sendData(data) {
  console.log('data to send', data);
  const url = `https://centauriproapi.azurewebsites.net/marketplace/Callback/customer/centauri/Q6t62QwXSyRusRufl0KeAdTs7iM2`;
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };
  return fetch(url, requestOptions)
    .then((res) => res);
}

function Copyright({ companyName, website }, props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href={website}>
        {companyName}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();
function App() {

  const [loading, setLoading] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  const title = 'Canadá te espera';
  const subtitle = 'Inicia aquí tu proceso de aceptación al College. ¡Te esperamos pronto en Canadá!';
  const inputs = [
    {
      name: 'email',
      label: 'Correo electrónico',
      type: 'email',
      required: true,
      autoComplete: 'email',
      autoFocus: true,
    },
    {
      name: 'full_name',
      label: 'Nombre completo',
      type: 'text',
      required: true,
      autoComplete: 'full_name',
      autoFocus: false,
    },
    {
      name: 'phone',
      label: 'Teléfono',
      type: 'text',
      required: true,
      autoComplete: 'phone',
      autoFocus: false,
    },
    {
      name: 'address',
      label: 'Dirección',
      type: 'address',
      required: true,
      autoComplete: 'address',
      autoFocus: false,
    },
    {
      name: 'city',
      label: 'Ciudad',
      type: 'text',
      required: true,
      autoComplete: 'city',
      autoFocus: false,
    },
    {
      name: 'program',
      label: 'Programa',
      type: 'select',
      required: true,
      autoComplete: 'program',
      autoFocus: false,
      options: [
        /*         {
                  value: 'Administrative Support in Clinical Settings (STC)',
                  label: 'Administrative Support in Clinical Settings (STC)',
                },
                {
                  value: 'Care Assistance in a Private Seniors’ Residence (STC)',
                  label: 'Care Assistance in a Private Seniors’ Residence (STC)',
                },
                {
                  value: 'Institutional and Home Care Assistance (PAB)',
                  label: 'Institutional and Home Care Assistance (PAB)',
                },
                {
                  value: 'Health, Assistance and Nursing',
                  label: 'Health, Assistance and Nursing',
                },
                {
                  value: 'Pharmacy Technical Assistance',
                  label: 'Pharmacy Technical Assistance',
                },
                {
                  value: 'Sales Representation',
                  label: 'Sales Representation',
                },
                {
                  value: 'Professional Sales',
                  label: 'Professional Sales',
                },
                {
                  value: 'Starting a Business',
                  label: 'Starting a Business',
                },
                {
                  value: 'Accounting',
                  label: 'Accounting',
                },
                {
                  value: 'Administrative Assistant – Secretarial Studies',
                  label: 'Administrative Assistant – Secretarial Studies',
                },
                {
                  value: 'Power Engineering (Stationary Engine Mechanics)',
                  label: 'Power Engineering (Stationary Engine Mechanics)',
                },
                {
                  value: 'Masonry : Bricklaying',
                  label: 'Masonry : Bricklaying',
                },
                {
                  value: 'Heavy Vehicle Mechanics',
                  label: 'Heavy Vehicle Mechanics',
                },
                {
                  value: 'Mécanique de véhicules lourds routiers (offert en français)',
                  label: 'Mécanique de véhicules lourds routiers (offert en français)',
                },
                {
                  value: 'Electric Vehicle Mechanics (AVS)',
                  label: 'Electric Vehicle Mechanics (AVS)',
                },
                {
                  value: 'Automobile Mechanics',
                  label: 'Automobile Mechanics',
                }, */
        {
          value: 'Digital Transformation 4.0',
          label: 'Digital Transformation 4.0'
        },
        {
          value: 'Industrial Drafting',
          label: 'Industrial Drafting'
        },
        {
          value: 'Design, Multimedia Integrations & Adaptive Web',
          label: 'Design, Multimedia Integrations & Adaptive Web'
        },
        {
          value: 'Residential And Commercial Drafting',
          label: 'Residential And Commercial Drafting'
        },
        {
          value: 'Computing support',
          label: 'Computing support'
        }
      ]
    }
  ]


  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    inputs.forEach(input => {
      console.log(input.name, data.get(input.name));
    });
    const payload = {
      "email": data.get('email'),
      "name": data.get('full_name'),
      "cardId": "-",
      "idType": "-",
      "phoneNumber": data.get('phone'),
      "address": {
        "address": data.get('address'),
        "city": data.get('city'),
      },
      "features": [
        {
          "key": "program",
          "value": data.get('program')
        },
        {
          "key": "origin",
          "value": "milestone"
        },
        {
          "key": "city",
          "value": data.get('city')
        }
      ]
    };
    setLoading(true);
    sendData(payload).then(() => {
      setLoading(false);
      setSent(true);
    }
    );
  };
  return (<ThemeProvider theme={theme}>
    <Grid container component="main" sx={{ height: '100vh' }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: 'url(https://source.unsplash.com/random?montreal)',
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            mt: 0,
            mb: 8,
            mx: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

          {/* <img height={'96px'} src={"/static/logo-doble-1.png"} alt="Canadá College" /> */}
          <Box sx={{ background: "#84202a", width: '100%', p: '20px',             display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', }}>
            <img height={'96px'} src={"https://centauriprostorage.blob.core.windows.net/centauri/logo-footer.png"} alt="Canadá College" />
          </Box>
          <Box sx={{ mx: 4, textAlign: 'center' }}>
            <Typography sx={{ mb: '20px', mt: '20px' }} component="h1" variant="h5">
              {title}
            </Typography>
            {!sent && <Typography sx={{ textAlign: 'center' }} component="p">
              {subtitle}
            </Typography>}

            {!sent && <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              {inputs.map((input, index) => {
                if (input.type === 'select') {
                  return (
                    <FormControl sx={{ mt: '20px' }} fullWidth key={index}>
                      <InputLabel id={`${input.name}-label`}>{input.label}</InputLabel>
                      <Select
                        labelId={`${input.name}-label`}
                        id={input.name}
                        label={input.label}
                        name={input.name}
                        aria-label={input.label}
                        required={input.required}
                        autoComplete={input.autoComplete}
                        autoFocus={input.autoFocus}
                      >
                        {input.options.map((option, index) => {
                          return (
                            <MenuItem value={option.value} key={index}>{option.label}</MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                  )
                }
                return (
                  <TextField
                    margin="normal"
                    required={input.required}
                    fullWidth
                    aria-label={input.label}
                    id={input.name}
                    label={input.label}
                    name={input.name}
                    autoComplete={input.autoComplete}
                    autoFocus={input.autoFocus}
                    key={index}
                  />
                )
              })}
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label={<><span> Aceptar </span> <a target={'_blank'} href={'https://visas.atlassian.net/servicedesk/customer/portal/2/article/35946497'}>términos y condiciones</a></>}
              />

              {!loading && <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, background: "#84202a" }}
              >
                Ir al College
              </Button>}
              {loading && <CircularProgress />}
              <Copyright sx={{ mt: 5 }} companyName='Intercampus' website='https://intercampus.co' />
            </Box>}
            {sent && <Box sx={{ mt: 1 }}>
              <Typography sx={{ textAlign: 'center' }} component="p">
                Gracias por registrarte, recibirás un correo con tu carta de oferta. Si no la recibes en 4 horas, por favor contáctanos.
                ¡Te esperamos pronto en Canadá!
              </Typography>
              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, background: "#84202a" }}
                onClick={() => setSent(false)}
              >
                Volver
              </Button>
            </Box>

            }
          </Box>
        </Box>
      </Grid>
    </Grid>
  </ThemeProvider>
  );
}

export default App;
